import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Link from '@panneau/element-link';

var styles = {"container":"panneau-filter-label-container","disabled":"panneau-filter-label-disabled","button":"panneau-filter-label-button","link":"panneau-filter-label-link","label":"panneau-filter-label-label","sublabel":"panneau-filter-label-sublabel"};

var _excluded = ["label", "sublabel", "href", "disabled", "onClick", "className"];
var propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  sublabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  href: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  label: null,
  sublabel: null,
  href: null,
  disabled: false,
  onClick: null,
  className: null
};
var LabelFilter = function LabelFilter(_ref) {
  var label = _ref.label,
    sublabel = _ref.sublabel,
    href = _ref.href,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var inner = /*#__PURE__*/React.createElement(React.Fragment, null, label !== null ? /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, label) : null, sublabel !== null ? /*#__PURE__*/React.createElement("span", {
    className: styles.sublabel
  }, sublabel) : null);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty({}, styles.disabled, disabled), className, className !== null)])
  }, href === null && onClick !== null ? /*#__PURE__*/React.createElement("button", Object.assign({
    type: "button",
    onClick: onClick,
    disabled: disabled,
    className: styles.button
  }, props), inner) : null, href !== null ? /*#__PURE__*/React.createElement(Link, Object.assign({
    className: styles.link,
    href: href,
    onClick: onClick
  }, props), inner) : null, href === null && onClick === null ? inner : null);
};
LabelFilter.propTypes = propTypes;
LabelFilter.defaultProps = defaultProps;

export { LabelFilter as default };
